<template>
  <v-list-tile @click="route" v-if="authorized">
    <v-list-tile-action>
      <v-icon>{{ item.icon }}</v-icon>
    </v-list-tile-action>
    <v-list-tile-content>
      <v-list-tile-title>{{ item.title }}</v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action v-if="group">
      <v-icon>keyboard_arrow_down</v-icon>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
import { EventBus } from '@/utils/Global'

export default {
  props: {
    item: Object,
    group: Boolean
  },
  methods: {
    route () {
      if (this.$route.fullPath === this.item.href) {
        EventBus.$emit('refresh')
      } else {
        this.$router.push(this.item.href)
      }
    }
  },
  computed: {
    authorized () {
      if (this.item.role) {
        return this.$auth.hasRole(this.item.role, this.item.ignoreDelegations)
      }
      if (this.item.roles) {
        return this.$auth.hasRole(this.item.roles, this.item.ignoreDelegations)
      }
      return true
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// NavigationItem.vue?1d3bd484